import React from 'react'
import { Line } from 'react-chartjs-2'
import { Grid, Segment } from 'semantic-ui-react'

const options = {
  fill: false,
  lineTension: 0.1,
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBackgroundColor: '#fff',
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBorderColor: 'rgba(220,220,220,1)',
  pointHoverBorderWidth: 2,
  pointRadius: 1,
  pointHitRadius: 10,
}

export default class OrderDriverLifeSpan extends React.PureComponent {
  render() {
    const {
      muuverLifeSpan,
      orderLifeSpan,
      chartLabels,
      onlineLifeSpan,
      offlineLifeSpan,
    } = this.props

    const firstOptions = {
      labels: chartLabels,
      datasets: [
        {
          ...options,
          label: 'Online Activities',
          backgroundColor: '#338a3e',
          borderColor: '#338a3e',
          pointHoverBackgroundColor: '#338a3e',
          pointBorderColor: '#338a3e',
          data: onlineLifeSpan,
        },
        {
          ...options,
          label: 'Offline Activities',
          backgroundColor: '#b61827',
          borderColor: '#b61827',
          pointBorderColor: '#b61827',
          pointHoverBackgroundColor: '#b61827',
          data: offlineLifeSpan,
        },
      ],
    }

    const secondOptions = {
      labels: chartLabels,
      datasets: [
        {
          ...options,
          label: 'Muuver Lifespan',
          backgroundColor: '#2196f3',
          borderColor: '#2196f3',
          pointBorderColor: '#2196f3',
          pointHoverBackgroundColor: '#2196f3',
          data: muuverLifeSpan,
        },
        {
          ...options,
          label: 'Order Lifespan',
          backgroundColor: '#ffc107',
          borderColor: '#ffc107',
          pointBorderColor: '#ffc107',
          pointHoverBackgroundColor: '#ffc107',
          data: orderLifeSpan,
        },
      ],
    }

    return (
      <Grid columns={2}>
        <Grid.Column key={1}>
          <Segment>
            <div>
              <Line data={firstOptions} />
            </div>
          </Segment>
        </Grid.Column>

        <Grid.Column key={2}>
          <Segment>
            <div>
              <Line data={secondOptions} />
            </div>
          </Segment>
        </Grid.Column>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/lineCharts.js